import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';


import Navigation from '../components/navigation';
import Footer from '../components/footer';
import SEO from '../components/SEO';

import '../../sass/style.scss';

const TemplateWrapper = ({ children }) => (
  <div className="content--body">
    <Helmet title="Radiologie Bregenz">
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
    </Helmet>
    <SEO />
    <Navigation />
    {children()}
    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js